import { render, staticRenderFns } from "./ContainerStyleEditor.vue?vue&type=template&id=1fbff28b&scoped=true"
import script from "./ContainerStyleEditor.vue?vue&type=script&lang=js"
export * from "./ContainerStyleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbff28b",
  null
  
)

export default component.exports